/** @jsxImportSource @emotion/react */
import React from "react";
import "./AmountLabel.css";
import Skeleton from "react-loading-skeleton";
import { css } from "@emotion/react";

export interface AmountLabelProps {
  amountToDisplay: string;
  visible: boolean;
  isSliderApplicable: boolean;
  shouldDisplayShimmer?: boolean;
}

export const AmountLabel: React.FC<AmountLabelProps> = props => {
  if (!props.visible) {
    return null;
  }
  return (
    <div
      className={`${
        props.isSliderApplicable
          ? "col-md-auto col-auto"
          : "col-sm-auto col-auto d-flex justify-content-end px-0 amount-label-section"
      }`}
    >
      <div
        className={`${props.isSliderApplicable ? "amt-one-to-many" : "amount-label"}`}
        css={css`
          font-size: 20px;
        `}
        data-sentry-mask="true"
        data-testid="tradeleg-amount-label"
      >
        {props.shouldDisplayShimmer || false ? (
          <Skeleton
            baseColor={"#4D5D5D"}
            highlightColor={"#33454566"}
            borderRadius={4}
            width={100}
          />
        ) : (
          props.amountToDisplay
        )}
      </div>
    </div>
  );
};
